import { from as rxFrom } from "rxjs/observable/from";
import { zip as rxZip } from "rxjs/observable/zip";
import { map, mergeMap, tap } from "rxjs/operators";
import { Primitive } from "./primitive";
import { Mat4 } from "../game-engine/transform";
var Mesh = (function () {
    function Mesh(gl_context_, gltf_data_, mesh_index_, transform_, material_loader_, buffer_loader_) {
        this.gl_context_ = gl_context_;
        this.gltf_data_ = gltf_data_;
        this.mesh_index_ = mesh_index_;
        this.transform_ = transform_;
        this.material_loader_ = material_loader_;
        this.buffer_loader_ = buffer_loader_;
        this.primitives_ = [];
        this.can_draw_primitives_ = false;
        this.view_matrix_ = new Mat4();
        this.inverse_view_matrix_ = new Mat4();
        this.projection_matrix_ = new Mat4();
        this.normal_matrix_ = new Mat4();
    }
    ;
    Mesh.prototype.createMesh = function () {
        var _this = this;
        var primitives = this.gltf_data_.meshes[this.mesh_index_].primitives;
        this.mesh_creation_subscription = rxFrom(primitives)
            .pipe(map(function (primitive_data) {
            return new Primitive(_this.gl_context_, _this.gltf_data_, _this.material_loader_, _this.buffer_loader_, primitive_data);
        }), tap(function (primitive) { return _this.primitives_.push(primitive); }), mergeMap(function (primitive) {
            return rxZip(primitive.loadMaterial(), primitive.loadVertexData());
        }))
            .subscribe(function (data) { console.log(data); }, function (err) { console.log(err); }, function () {
            _this.can_draw_primitives_ = true;
        });
    };
    ;
    Mesh.prototype.preMultiplyMatrices = function (view, projection) {
        this.transform_.updateTransform();
        Mat4.multiply(view, this.transform_.transform, this.view_matrix_);
        Mat4.multiply(projection, this.view_matrix_, this.projection_matrix_);
        this.view_matrix_.inverse(this.inverse_view_matrix_);
        this.inverse_view_matrix_.transpose(this.normal_matrix_);
    };
    ;
    Mesh.prototype.drawMesh = function (shader_program) {
        if (!this.can_draw_primitives_)
            return;
        this.gl_context_.uniformMatrix4fv(shader_program.getUniform("u_view_matrix"), false, this.view_matrix_.array);
        this.gl_context_.uniformMatrix4fv(shader_program.getUniform("u_projection_matrix"), false, this.projection_matrix_.array);
        this.gl_context_.uniformMatrix3fv(shader_program.getUniform("u_normal_matrix"), false, this.normal_matrix_.mat3);
        this.primitives_.forEach(function (primitive) { return primitive.draw(shader_program); });
    };
    ;
    return Mesh;
}());
export { Mesh };
//# sourceMappingURL=mesh.js.map